import React from "react";
import moment from "../../../helper/moment";

import { ReactComponent as WomanPatient } from "../../../assets/illustrations/illustration-femme-patienta.svg";
import { ReactComponent as ManPatient } from "../../../assets/illustrations/illustration-homme-patienta.svg";
import "./styles.scss";

const colorAvatar = [
  "#ccd2ff",
  "#d5f0f7",
  "#ffecba",
  "#fff7ab",
  "#ffccd2",
  "#ffe2c8",
];

interface IPatientDetails {
  updatedAt: Date;
  demandes: any;
  firstName: string;
  lastName: string;
  _id: string;
  date: Date;
  type: string;
  gender: string;
  dateDerniereDemande: Date;
  motifs: string;
}

type Props = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  patientDetails: IPatientDetails;
  openModal: boolean;
  setOpenModal: Function;
  setSelectedPatient: Function;
  setChatModal: Function;
  selectedPatient: string;
  setColorIndex: Function;
  i: number;
};

const CardPatient: React.FC<Props> = ({
  patientDetails,
  openModal,
  setOpenModal,
  setSelectedPatient,
  selectedPatient,
  setChatModal,
  setColorIndex,
  i,
}) => {
  const isSelected = selectedPatient === patientDetails?._id;
  return (
    <div
      key={i}
      className={`
        flex items-center justify-between bg-white cursor-pointer mb-4
        w-full transition-all duration-200 ease-in-out
        rounded-xl p-4 min-h-[123px]
        ${isSelected ? "border-[3px] border-[#4565F6] shadow-lg" : "border border-gray-100 hover:shadow-md"}
      `}
      onClick={() => {
        setSelectedPatient(patientDetails?._id);
        setOpenModal(!openModal);
        setColorIndex(i);
      }}
    >
      <div className="flex items-center w-full">
        <div
          className="rounded-full h-12 w-12 flex items-center justify-center shrink-0 mx-2 sm:mx-5"
          style={{
            backgroundColor: colorAvatar[i % colorAvatar.length],
          }}
        >
          {patientDetails.gender === "male" ? (
            <ManPatient className="w-8 h-8" />
          ) : (
            <WomanPatient className="w-8 h-8" />
          )}
        </div>

        <div className="flex flex-col flex-grow min-w-0 pr-2">
          <p className="text-lg font-semibold text-gray-800 capitalize truncate">
            {patientDetails.firstName} {patientDetails.lastName}
          </p>

          {patientDetails.dateDerniereDemande ? (
            <p className="text-xs sm:text-sm text-gray-500 font-medium mt-1">
              Dernière demande le{" "}
              <span className="font-bold text-gray-700">
                {moment(patientDetails.dateDerniereDemande).format("DD/MM/YYYY à HH:mm")}
              </span>
            </p>
          ) : (
            <div className="h-4" />
          )}

          {patientDetails.motifs && (
            <div className="mt-2">
              <span className="inline-block bg-gray-50 px-3 py-1 text-xs font-semibold text-indigo-600 rounded-full shadow-sm border border-indigo-50 truncate max-w-full">
                {patientDetails.motifs}
              </span>
            </div>
          )}
        </div>
      </div>

      <div className="flex items-center shrink-0">
      </div>
    </div>
  );
};

export default CardPatient;
